module.exports = __webpack_public_path__ + "cf7f4fe1deebff25326ae29e504b7abc.jpg";